module.exports = __webpack_public_path__ + "static/media/2017-image.ef3e4014.png";